export enum ErrorType {
  CLIENT_ERROR = 'clientError',
  NOT_FOUND = 'notFound',
  SERVER_ERROR = 'serverError',
  EMPTY_WISHLIST = 'emptyWishlist',
  UNAUTHORIZED = 'unAuthorized',
}
